import * as o from "react";
import s from "../lib/IconBase.es.js";
import a from "../defs/Desktop.es.js";
const e = o.forwardRef((t, r) => /* @__PURE__ */ o.createElement(s, { ref: r, ...t, weights: a }));
e.displayName = "DesktopIcon";
const c = e;
export {
  c as Desktop,
  e as DesktopIcon
};
